var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFiles = function SvgFiles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 152,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M146.132 21.43a3.328 3.328 0 0 0-3.166-3.007L41.029 12.604a3.166 3.166 0 0 0-3.358 2.881c-1.45 16.288-8.108 93.105-8.231 129.188a3.256 3.256 0 0 0 3.134 3.226l96.53 3.099a3.166 3.166 0 0 0 3.219-2.678c10.08-62.612 14.863-114.372 13.809-126.89Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.664 15.486c-1.45 16.288-8.108 93.104-8.231 129.187a3.259 3.259 0 0 0 3.13 3.226l16.194.52 71.143-8.893a3.635 3.635 0 0 0 2.264-1.205 3.638 3.638 0 0 0 .902-2.401c.177-57.55-1.846-95.748-3.77-118.848l-78.267-4.47a3.166 3.166 0 0 0-3.365 2.884Z",
    fill: "#F4F5F7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M146.132 21.43a3.328 3.328 0 0 0-3.166-3.007L41.029 12.604a3.166 3.166 0 0 0-3.358 2.881c-1.45 16.288-8.108 93.105-8.231 129.188a3.256 3.256 0 0 0 3.134 3.226l96.53 3.099a3.166 3.166 0 0 0 3.219-2.678c10.08-62.612 14.863-114.372 13.809-126.89v0Z",
    stroke: "#ABB2BC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M81.867 1 3.876 8.398a3.166 3.166 0 0 0-2.868 3.372c1.104 16.316 6.496 93.266 12.01 128.915a3.205 3.205 0 0 0 3.568 2.675l95.849-11.979a3.206 3.206 0 0 0 2.777-3.166c.171-56.385-2.058-91.639-3.891-110.934A49.253 49.253 0 0 0 81.867 1Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m27.663 119.791 38.65-4.831m13.022-34.896 15.458-1.934m-69.64 8.706 41.183-5.138m-43.57-11.362 61.78-7.721M25.316 103.61l2.533-.316 69.507-8.69-72.04 9.006Z",
    stroke: "#EAECEE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M111.309 17.275A49.255 49.255 0 0 0 81.867 1l-7.984.756c-.06 6.832.592 17.456 4.562 24.924a5.622 5.622 0 0 0 5.505 2.925 120.34 120.34 0 0 0 27.89-6.53 338.5 338.5 0 0 0-.531-5.8Z",
    fill: "#F4F5F7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M81.867 1 3.876 8.398a3.166 3.166 0 0 0-2.868 3.372c1.104 16.316 6.496 93.266 12.01 128.915a3.205 3.205 0 0 0 3.568 2.675l95.849-11.979a3.206 3.206 0 0 0 2.777-3.166c.171-56.385-2.058-91.639-3.891-110.934A49.253 49.253 0 0 0 81.867 1v0Z",
    stroke: "#ABB2BC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M88.261 23.666a68.13 68.13 0 0 0 23.047-6.391A49.254 49.254 0 0 0 81.867 1s-1.349 12.98 2.785 20.748a3.676 3.676 0 0 0 3.61 1.918Z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M88.261 23.666a68.13 68.13 0 0 0 23.047-6.391A49.254 49.254 0 0 0 81.867 1s-1.349 12.98 2.785 20.748a3.676 3.676 0 0 0 3.61 1.918Z",
    stroke: "#ABB2BC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M123.139 34.276 102.8 36.184a3.166 3.166 0 0 0-2.856 3.448l1.075 11.457a3.165 3.165 0 0 0 3.447 2.856l20.34-1.908a3.166 3.166 0 0 0 2.856-3.447l-1.075-11.458a3.166 3.166 0 0 0-3.448-2.856Z",
    fill: "#D5D9DE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m127.659 48.594-1.073-11.46a3.166 3.166 0 0 0-3.447-2.85l-6.275.59 1.415 17.784 6.525-.61a3.169 3.169 0 0 0 2.731-2.224c.122-.398.164-.816.124-1.23Z",
    fill: "#EAECEE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M123.139 34.276 102.8 36.184a3.166 3.166 0 0 0-2.856 3.448l1.075 11.457a3.165 3.165 0 0 0 3.447 2.856l20.34-1.908a3.166 3.166 0 0 0 2.856-3.447l-1.075-11.458a3.166 3.166 0 0 0-3.448-2.856Z",
    stroke: "#ABB2BC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m148.651 107.924-20.192-3.095a3.165 3.165 0 0 0-3.609 2.65l-1.744 11.374a3.167 3.167 0 0 0 2.65 3.609l20.193 3.095a3.166 3.166 0 0 0 3.609-2.65l1.743-11.374a3.166 3.166 0 0 0-2.65-3.609Z",
    fill: "#D5D9DE"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m148.664 107.926-9.111-1.4a3.167 3.167 0 0 1 .76 2.58l-2.235 14.598a3.286 3.286 0 0 1-.162.633l8.044 1.234a3.166 3.166 0 0 0 3.609-2.649l1.745-11.375a3.187 3.187 0 0 0-.051-1.238 3.144 3.144 0 0 0-.522-1.123 3.145 3.145 0 0 0-.913-.837 3.15 3.15 0 0 0-1.164-.423Z",
    fill: "#EAECEE"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m148.651 107.924-20.192-3.095a3.165 3.165 0 0 0-3.609 2.65l-1.744 11.374a3.167 3.167 0 0 0 2.65 3.609l20.193 3.095a3.166 3.166 0 0 0 3.609-2.65l1.743-11.374a3.166 3.166 0 0 0-2.65-3.609Z",
    stroke: "#ABB2BC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m151.816 82.598-20.193-3.095a3.166 3.166 0 0 0-3.609 2.65l-1.743 11.374a3.165 3.165 0 0 0 2.65 3.609l20.192 3.095a3.166 3.166 0 0 0 3.609-2.65l1.744-11.374a3.167 3.167 0 0 0-2.65-3.61Z",
    fill: "#D5D9DE"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m151.83 82.6-6.648-1.015-2.704 17.633 6.623 1.016a3.167 3.167 0 0 0 3.609-2.65l1.744-11.374a3.167 3.167 0 0 0-2.624-3.61Z",
    fill: "#F4F5F7"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m151.816 82.598-20.193-3.095a3.166 3.166 0 0 0-3.609 2.65l-1.743 11.374a3.165 3.165 0 0 0 2.65 3.609l20.192 3.095a3.166 3.166 0 0 0 3.609-2.65l1.744-11.374a3.167 3.167 0 0 0-2.65-3.61Z",
    stroke: "#ABB2BC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m151.816 82.598-20.193-3.095a3.166 3.166 0 0 0-3.609 2.65l-1.743 11.374a3.165 3.165 0 0 0 2.65 3.609l20.192 3.095a3.166 3.166 0 0 0 3.609-2.65l1.744-11.374a3.167 3.167 0 0 0-2.65-3.61Z",
    stroke: "#ABB2BC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.2069 .97836 -.98355 .18063 36.272 34.432)",
    stroke: "#ABB2BC",
    strokeWidth: 1.992,
    strokeLinecap: "round",
    d: "M.996-.996h4.73"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.2069 .97836 -.98355 .18063 43.268 33.147)",
    stroke: "#ABB2BC",
    strokeWidth: 1.992,
    strokeLinecap: "round",
    d: "M.996-.996h4.73"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M32.265 42.039c.658 1.339.11 2.92-1.22 3.538-1.33.617-2.94.038-3.599-1.3-.658-1.34-.11-2.921 1.22-3.539 1.33-.617 2.94-.038 3.599 1.3ZM55.153 35.823c.659 1.338.11 2.92-1.219 3.538-1.33.617-2.94.038-3.6-1.3-.658-1.34-.11-2.921 1.22-3.539 1.33-.617 2.941-.038 3.6 1.3Z",
    fill: "#F4F5F7"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M49.601 41.088c.615 3.758-2.185 7.253-6.252 7.807-4.068.553-7.864-2.045-8.478-5.803",
    stroke: "#ABB2BC",
    strokeWidth: 1.992,
    strokeLinecap: "round"
  })));
};

export default SvgFiles;